"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetDetailModal = void 0;
var AssetDetailModal_1 = require("./AssetDetailModal");
Object.defineProperty(exports, "AssetDetailModal", { enumerable: true, get: function () { return AssetDetailModal_1.AssetDetailModal; } });
